import React from 'react';
import Week from 'react-big-calendar/lib/Week';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';

function workWeekRange(date: Date, options: any): Date[] {
    let remain = [new Date()];
    let diff = 7 - remain.length;
    let ndate = new Date(remain[0].getTime());
    for (var i = 0; i < diff; i++) {
        ndate.setDate(ndate.getDate() + 1);
        remain.push(new Date(ndate.getTime()));
    }
    return remain;
}

interface WorkWeekProps {
    date: Date;
    [key: string]: any;
}

class MyWorkWeek extends React.Component<WorkWeekProps> {
    render() {
        let { date, ...props } = this.props;
        let range = workWeekRange(date, this.props);

        return (
            <TimeGrid
                {...props}
                range={range}
                eventOffset={15}
            />
        );
    }
}

(MyWorkWeek as any).defaultProps = TimeGrid.defaultProps;

(MyWorkWeek as any).range = workWeekRange;

(MyWorkWeek as any).navigate = Week.navigate;

(MyWorkWeek as any).title = (date: Date, { localizer }: any) => {
    let [start, ...rest] = workWeekRange(date, { localizer });
    return localizer.format({ start, end: rest.pop() }, 'dayRangeHeaderFormat');
};

export default MyWorkWeek;
